import React from 'react';

export const DragNDrop = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M28 20h1a1 1 0 0 0 1-1v-1h-2v2ZM26 18h-2v2h2v-2ZM14 6h-2v2h2V6ZM14 2h-1a1 1 0 0 0-1 1v1h2V2ZM18 2h-2v2h2V2ZM22 2h-2v2h2V2ZM26 2h-2v2h2V2ZM29 2h-1v2h2V3a1 1 0 0 0-1-1ZM30 6h-2v2h2V6ZM30 14h-2v2h2v-2ZM30 10h-2v2h2v-2ZM24 14V8h-6v2h2.59l-8.8 8.79 1.42 1.42 4.79-4.8V28H4V14h11v-2h-1v-2h-2v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9h2v-2h-2v-4.59l2-2V14h2Z" />
    </svg>
);
